import { Relationship } from './relationship.model'
import { config } from '../config/config'

import * as moment from 'moment'
moment.locale('fr')

export enum Roles {
  member,
  admin
}

export enum Sex {
  M,
  F,
  O
}

export class User {
  public id = ''
  public firstname = ''
  public lastname = ''
  public maidenName = ''
  public avatar = ''
  public sex = Sex.O
  public dob: moment.Moment = null
  public dop: moment.Moment = null
  public email = ''
  public address = ''
  public city = ''
  public zipcode = ''
  public country = ''
  public role = Roles.member
  public relationships: Relationship[] = []
  public notificationsPublicNew = false
  public notificationsPublicUpcoming = false
  public notificationsPublicDeleted = false
  public notificationsPublicDate = false
  public notificationsPrivateNew = true
  public notificationsPrivateUpcoming = true
  public notificationsPrivateDeleted = true
  public notificationsPrivateDate = true
  public notificationsComment = true
  public deletedAt: moment.Moment = null

  cast (data: Object) {
    Object.keys(data).forEach((key) => {
      if (this.hasOwnProperty(key)) {
        switch (key) {
          case 'role':
            const role: string = data[key]
            this[key] = Roles[role] || Roles.member
            break
          case 'sex':
            const sex: string = data[key]
            this[key] = typeof Sex[sex] !== 'undefined' ? Sex[sex] : Sex.O
            break
          case 'dob':
          case 'dop':
          case 'deletedAt':
            this[key] = data[key] ? moment.utc(data[key]) : null
            break
          case 'relationships':
            this[key] = data[key].map((r) => new Relationship().cast(r))
            break
          default:
            this[key] = data[key]
            break
        }
      }
    })

    return this
  }

  isAdmin () {
    return this.role === Roles.admin
  }

  copy (user: User) {
    this.id = user.id
    this.firstname = user.firstname
    this.lastname = user.lastname
    this.maidenName = user.maidenName
    this.avatar = user.avatar
    this.sex = user.sex
    this.dob = user.dob
    this.dop = user.dop
    this.email = user.email
    this.address = user.address
    this.city = user.city
    this.zipcode = user.zipcode
    this.country = user.country
    this.role = user.role
    this.relationships = user.relationships
    this.notificationsPublicNew = user.notificationsPublicNew
    this.notificationsPublicUpcoming = user.notificationsPublicUpcoming
    this.notificationsPublicDeleted = user.notificationsPublicDeleted
    this.notificationsPublicDate = user.notificationsPublicDate
    this.notificationsPrivateNew = user.notificationsPrivateNew
    this.notificationsPrivateUpcoming = user.notificationsPrivateUpcoming
    this.notificationsPrivateDeleted = user.notificationsPrivateDeleted
    this.notificationsPrivateDate = user.notificationsPrivateDate
    this.notificationsComment = user.notificationsComment
  }

  reset () {
    this.id = ''
    this.firstname = ''
    this.lastname = ''
    this.maidenName = ''
    this.avatar = ''
    this.sex = Sex.O
    this.dob = null
    this.dop = null
    this.email = ''
    this.address = ''
    this.city = ''
    this.zipcode = ''
    this.country = ''
    this.role = Roles.member
    this.relationships = []
  }

  getRoleLabel (label) {
    const role = typeof label !== 'undefined' ? label : this.role
    switch (role) {
      case Roles.admin:
        return 'Administrateur'
      case Roles.member:
        return 'Membre'
      default:
        return 'Membre'
    }
  }

  getSexLabel (label) {
    const sex = typeof label !== 'undefined' ? label : this.sex
    switch (sex) {
      case Sex.F:
        return 'Femme'
      case Sex.M:
        return 'Homme'
      case Sex.O:
        return 'Autre'
      default:
        return 'Autre'
    }
  }
}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./app/models/user.model.ts